import { atsApiQuery } from '..';

export const atsApplicationApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getAllJobs: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs`,
            method: 'get',
            params,
          };
        },
      }),
      getAllJobsList: builder.query({
        transformResponse: (response) => response?.data?.ats_jobs,
        query: ({ params }) => {
          return {
            url: `ats_jobs/list`,
            method: 'get',
            params,
          };
        },
      }),
      getHiringTeamOfTheJob: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ jobId, users = false, params }) => {
          let url = `ats_jobs/${jobId}/ats_hiring_teams`;
          if (users) {
            url = `ats_jobs/${jobId}/ats_hiring_teams/users`;
          }
          return {
            url,
            method: 'get',
            params,
          };
        },
      }),
      getHiringTeamBasedOnHTandApplicationId: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ jobId, users = false, params, appId }) => {
          let url = `ats_jobs/${jobId}/ats_hiring_teams/users?role_name[]=job_hiring_manager&role_name[]=job_recruiter&role_name[]=job_coordinator&ats_application_id=${appId}`;
          return {
            url,
            method: 'get',
            params,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetAllJobsQuery,
  useGetAllJobsListQuery,
  useGetHiringTeamOfTheJobQuery,
  useLazyGetHiringTeamOfTheJobQuery,
  useGetHiringTeamBasedOnHTandApplicationIdQuery,
} = atsApplicationApi;
